(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serum-danke"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('serum-thanks-coupon')) {
  customElements.define('serum-thanks-coupon', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      button.addEventListener('click', async () => {
        const endpoint = this.dataset.endpoint;
        if (!endpoint || !endpoint.startsWith('/apps/') || endpoint.includes('..')) return;
        button.disabled = true;
        status.textContent = this.dataset.loading;
        try {
          const response = await fetch(endpoint, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({campaign:'serum-lions-mane-danke'}), signal:AbortSignal.timeout(15000)});
          if (!response.ok) throw new Error('Coupon unavailable');
          const data = await response.json();
          if (typeof data.code !== 'string' || !/^[A-Za-z0-9_-]{4,80}$/.test(data.code)) throw new Error('Invalid coupon');
          this.querySelector('output').textContent = data.code;
          this.querySelector('a').href = '/discount/' + encodeURIComponent(data.code) + '?redirect=' + encodeURIComponent('/collections/all');
          this.querySelector('.serum-thanks__result').hidden = false;
          button.hidden = true;
          status.textContent = '';
        } catch (error) {
          status.textContent = this.dataset.error;
          button.disabled = false;
        }
      });
    }
  });
}

if (!customElements.get('serum-product-carousel')) {
  customElements.define('serum-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.carouselReady) return;
      this.carouselReady = true;
      const track = this.querySelector('.serum-library__track');
      const controls = this.querySelector('.serum-library__controls');
      const previous = controls.querySelector('[data-direction="-1"]');
      const next = controls.querySelector('[data-direction="1"]');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max < 2;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const move = direction => {
        const card = track.querySelector('li');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({left:direction * (card.getBoundingClientRect().width + gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      controls.querySelectorAll('button').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction))));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.carouselReady = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
